export default __webpack_public_path__ + "25002f0f0c9aa6bb624bb7044d68e4e2.jpg";